
/**
 * Definition of Mercado Pago gateway.
 * @typedef {Object} Gateway
 */
const mercadopago = {
  id: 'mercadopago',
  allowReusableUse: false,
  allowSingleUse: true,
  currencies: ['CLP'],
  flow: 'none',
  name: 'Mercado Pago'
}

/**
 * Definition of Webpay gateway.
 * @typedef {Object} Gateway
 */
const webpay = {
  id: 'webpay',
  allowReusableUse: false,
  allowSingleUse: true,
  currencies: ['CLP'],
  flow: 'redirect',
  name: 'Webpay'
}

/**
 * Definition of Getnet Click gateway.
 * @typedef {Object} Gateway
 */
const getnetclick = {
  id: 'getnetclick',
  allowReusableUse: true,
  allowSingleUse: false,
  currencies: ['CLP', 'USD'],
  flow: 'redirect',
  name: 'Getnet'
}

export default [
  {
    id: 'stripe',
    allowReusableUse: true,
    allowSingleUse: true,
    currencies: ['USD', 'MXN'],
    flow: 'none',
    name: 'Stripe',
    testMode: {
      publicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      card: {
        number: '4242 4242 4242 4242',
        date: '12 / 25',
        cvv: '123'
      }
    }
  },
  {
    id: 'paypal',
    allowReusableUse: false,
    allowSingleUse: true,
    currencies: ['USD', 'MXN'],
    flow: 'redirect',
    name: 'PayPal'
  },
  {
    id: 'oneclick',
    allowReusableUse: true,
    allowSingleUse: false,
    currencies: ['CLP'],
    flow: 'redirect',
    name: 'OneClick Transbank'
  },
  {
    id: 'twocheckout',
    allowReusableUse: false,
    allowSingleUse: true,
    currencies: ['USD'],
    flow: 'none',
    title: '2Checkout'
  },
  getnetclick,
  mercadopago,
  webpay
]
